import React from 'react'
import styled from '@emotion/styled'
import { AccountHeader } from '@mobi/component-library/Account'
import { Button } from '../../../../../component-library/src/Common/V2'
import { colors, font } from '../../../../../component-library/src/Theme/Common'
import { Content, Footer, SignUpPageStyled } from './SignUpPage.styled'
import {
  OnPasswordInputChangeProps,
  PasswordInput,
} from '@mobi/component-library/Signup/PasswordInput'

type Props = {
  onSubmit: () => void
  isBusy: boolean
  setPassword: (value: string) => void
}

export const Password = ({ onSubmit, isBusy, setPassword }: Props) => {
  const [canContinue, setCanContinue] = React.useState(false)

  const handlePasswordInputChange = ({ password, canContinue }: OnPasswordInputChangeProps) => {
    setPassword(password)
    setCanContinue(canContinue)
  }

  return (
    <SignUpPageStyled>
      <AccountHeader
        alignItems='start'
        title='Create your password'
        description='Create a password to keep your account secured.'
        style={{ marginBottom: '0rem' }}
      />
      <Content>
        <PasswordInput onPasswordInputChange={handlePasswordInputChange} isDisabled={isBusy} />
      </Content>
      <Footer>
        <Button
          aria-label='Continue button'
          color='primary'
          isFullWidth
          size='md'
          disabled={!canContinue}
          isLoading={isBusy}
          onClick={onSubmit}
        >
          Continue
        </Button>
        <HelperText>Complete all fields before continuing</HelperText>
      </Footer>
    </SignUpPageStyled>
  )
}

export const HelperText = styled.div({
  fontFamily: font.family.primary,
  color: colors.neutral[600],
  ...font.size.md,
})
